import { Button } from "@/components/ui/button";
import type { ReportActivitiesForm } from "@/Wist-blockchain/collections/reportActivities/types";
import { uid } from "../utils/uid-generator";

export type ActivityRow = ReportActivitiesForm & { id: string };
interface ActivitiesTableProps { activities: ActivityRow[]; onAdd: () => void; onRemove: (id: string) => void; onUpdate: (id: string, key: keyof ReportActivitiesForm, value: string) => void; }

export const createActivity = (order: number): ActivityRow => ({ id: uid(), order, idReport: "", activity: "", result: "", observations: "" });

export function ActivitiesTable({ activities, onAdd, onRemove, onUpdate }: ActivitiesTableProps) {

    const clearRow = (id: string) => {
        onUpdate(id, "activity", "")
        onUpdate(id, "result", "")
        onUpdate(id, "observations", "")
    }


    const cell = "w-full bg-transparent border border-transparent hover:border-border/60 focus:border-primary focus:bg-muted/30 rounded px-2 py-1 text-foreground placeholder:text-muted-foreground/30 outline-none transition-colors text-xs";
    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between">
                <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                    {activities.length} actividad{activities.length !== 1 ? "es" : ""}
                </span>
                <Button type="button" size="sm" variant="outline" onClick={onAdd}
                    className="cursor-pointer text-primary border-primary/30 hover:bg-primary/5 text-xs h-7 px-3">
                    + Agregar
                </Button>
            </div>
            <div className="rounded-lg border border-border/50 overflow-x-auto">
                <table className="w-full text-xs">
                    <thead>
                        <tr className="border-b border-border/40 bg-muted/30">
                            <th className="w-8 px-3 py-2 text-left text-muted-foreground font-medium text-[11px] uppercase tracking-wide">#</th>
                            <th className="px-3 py-2 text-left text-muted-foreground font-medium text-[11px] uppercase tracking-wide w-[34%]">Actividad</th>
                            <th className="px-3 py-2 text-left text-muted-foreground font-medium text-[11px] uppercase tracking-wide w-[20%]">Resultado</th>
                            <th className="px-3 py-2 text-left text-muted-foreground font-medium text-[11px] uppercase tracking-wide">Observaciones</th>
                            <th className="w-8" />
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-border/30">
                        {activities.map((a) => (
                            <tr key={a.id} className="hover:bg-muted/20 transition-colors">
                                <td className="px-3 py-1.5 text-muted-foreground/40 font-mono text-center text-[11px]">{a.order}</td>
                                <td className="px-1.5 py-1.5"><input type="text" placeholder="Descripción..." value={a.activity} onChange={(e) => onUpdate(a.id, "activity", e.target.value)} className={cell} /></td>
                                <td className="px-1.5 py-1.5"><input type="text" placeholder="OK / Falla / N/A" value={a.result} onChange={(e) => onUpdate(a.id, "result", e.target.value)} className={cell} /></td>
                                <td className="px-1.5 py-1.5"><input type="text" placeholder="Notas..." value={a.observations} onChange={(e) => onUpdate(a.id, "observations", e.target.value)} className={cell} /></td>
                                <td className="px-2 py-1.5">
                                    <button type="button"
                                        onClick={() => activities.length === 1 ? clearRow(a.id) : onRemove(a.id)}
                                        className="text-muted-foreground/20 hover:text-destructive transition-colors p-1 rounded cursor-pointer">✕</button>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    );
}

